import round from 'lodash/round';

export const toRateNumber = (
  value: string | number,
  precision?: number | undefined,
) => {
  const valueSanitized = String(value).replace(/[^0-9.]/g, '');

  let valueAbsolute = Math.abs(Number(valueSanitized));

  if (valueAbsolute < 1) {
    // value is less than 1, it's a decimal, so multiply by 100 to get a percentage value
    valueAbsolute *= 100;
  }

  return round(valueAbsolute, precision);
};
